import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Loader from "@/components/Loader";
import EmptyState from "@/components/EmptyState";

export default function Ateliers() {
  const [items, setItems] = useState(null);
  const [type, setType] = useState("all");
  const [loc, setLoc] = useState("all");

  useEffect(() => {
    api.get("/ateliers").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  const types = useMemo(() => Array.from(new Set((items || []).map(i => i.type).filter(Boolean))), [items]);
  const locations = useMemo(() => Array.from(new Set((items || []).map(i => i.location).filter(Boolean))), [items]);
  const filtered = useMemo(() => (items || []).filter(i => (type === "all" || i.type === type) && (loc === "all" || i.location === loc)), [items, type, loc]);

  if (!items) return <Loader label="Chargement des ateliers…" />;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-4xl font-black gradient-text inline-block">Ateliers</h1>
          <p className="text-neutral-400 mt-2">Découvrez plus de 40 ateliers pour tous les âges et tous les goûts.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <select value={type} onChange={(e) => setType(e.target.value)} className="bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2 text-sm" data-testid="filter-type">
            <option value="all">Tous types</option>
            {types.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <select value={loc} onChange={(e) => setLoc(e.target.value)} className="bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2 text-sm" data-testid="filter-location">
            <option value="all">Tous lieux</option>
            {locations.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
      </div>

      {filtered.length === 0 ? (
        <EmptyState title="Aucun atelier" subtitle="Modifiez les filtres." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((a) => {
            const color = a.colorHex || "#A1C861";
            return (
              <Link key={a.id} to={`/ateliers/${a.id}`} className="card-hsg p-5 hover:-translate-y-1 transition-transform block" data-testid={`atelier-card-${a.id}`}>
                <div className="chip mb-2" style={{ background: color + "22", color, border: `1px solid ${color}55` }}>{a.type}</div>
                <h3 className="font-bold text-lg leading-tight">{a.title}</h3>
                {a.subtitle && <p className="text-neutral-400 text-sm mt-1">{a.subtitle}</p>}
                {a.description && <p className="text-neutral-300 text-sm mt-3">{a.description}</p>}
                <div className="mt-4 flex flex-wrap gap-2 text-xs">
                  {a.location && <span className="chip" style={{ background: "#ffffff10", color: "#ccc", border: "1px solid #ffffff22" }}>📍 {a.location}</span>}
                  {a.age && <span className="chip" style={{ background: "#ffffff10", color: "#ccc", border: "1px solid #ffffff22" }}>👦 {a.age}</span>}
                  {a.time && <span className="chip" style={{ background: "#ffffff10", color: "#ccc", border: "1px solid #ffffff22" }}>⏰ {a.time}</span>}
                </div>
                {a.bookingEnabled && (
                  <div className="mt-4 text-xs font-bold text-[#5BC5F2]">🎫 Réservation possible →</div>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
